import { render, staticRenderFns } from "./Ancillary.vue?vue&type=template&id=8c96ca1c&"
import script from "./Ancillary.vue?vue&type=script&lang=js&"
export * from "./Ancillary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c96ca1c')) {
      api.createRecord('8c96ca1c', component.options)
    } else {
      api.reload('8c96ca1c', component.options)
    }
    module.hot.accept("./Ancillary.vue?vue&type=template&id=8c96ca1c&", function () {
      api.rerender('8c96ca1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Aggregation/Ancillary.vue"
export default component.exports